export enum CountryRegion {
  Caribbean = "Caribbean",
  North = "North",
  Central = "Central",
  South = "South",
  Andean = "Andean",
  Tropical = "Tropical"
}

export enum Country {
  Anguila = "Anguila",
  AntiguaAndBarbuda = "Antigua And Barbuda",
  Argentina = "Argentina",
  Bahamas = "Bahamas",
  Barbados = "Barbados",
  Belize = "Belize",
  Bermuda = "Bermuda",
  Bolivia = "Bolivia",
  Brasil = "Brasil",
  BritishVirginIslands = "British Virgin Islands",
  Canada = "Canada",
  Chile = "Chile",
  Colombia = "Colombia",
  CostaRica = "Costa Rica",
  Cuba = "Cuba",
  Dominica = "Dominica",
  Ecuador = "Ecuador",
  ElSalvador = "El Salvador",
  EstadosUnidosdeNA = "United States",
  Grenada = "Grenada",
  Groenlandia = "Groenlandia",
  Guatemala = "Guatemala",
  Guyana = "Guyana",
  Haiti = "Haiti",
  Honduras = "Honduras",
  Jamaica = "Jamaica",
  México = "México",
  Montserrat = "Montserrat",
  Nicaragua = "Nicaragua",
  Panamá = "Panamá",
  Paraguay = "Paraguay",
  Perú = "Perú",
  PuertoRico = "Puerto Rico",
  DominicanRepublic = "República Dominicana",
  SaintLucia = "Saint Lucia",
  SaintVincentandtheGrenadines = "Saint Vincent and the Grenadines",
  StKittsNevis = "StKittsNevis",
  Suriname = "Suriname",
  TrinidadandTobago = "Trinidad and Tobago",
  TurksCaicos = "Turks and Caicos",
  Uruguay = "Uruguay",
  Venezuela = "Venezuela",
};

export const RegionsByCountry: Map<Country, CountryRegion> = new Map([
  [Country.Anguila, CountryRegion.Caribbean],
  [Country.AntiguaAndBarbuda, CountryRegion.Caribbean],
  [Country.Argentina, CountryRegion.South],
  [Country.Bahamas, CountryRegion.Caribbean],
  [Country.Barbados, CountryRegion.Caribbean],
  [Country.Belize, CountryRegion.Caribbean],
  [Country.Bermuda, CountryRegion.Caribbean],
  [Country.Bolivia, CountryRegion.Andean],
  [Country.Brasil, CountryRegion.Tropical],
  [Country.BritishVirginIslands, CountryRegion.Caribbean],
  [Country.Canada, CountryRegion.North],
  [Country.Chile, CountryRegion.South],
  [Country.Colombia, CountryRegion.Central],
  [Country.CostaRica, CountryRegion.Central],
  [Country.Cuba, CountryRegion.Caribbean],
  [Country.Dominica, CountryRegion.Caribbean],
  [Country.DominicanRepublic, CountryRegion.Caribbean],
  [Country.Ecuador, CountryRegion.Andean],
  [Country.ElSalvador, CountryRegion.Central],
  [Country.EstadosUnidosdeNA, CountryRegion.North],
  [Country.Grenada, CountryRegion.Caribbean],
  [Country.Groenlandia, CountryRegion.North],
  [Country.Guatemala, CountryRegion.Central],
  [Country.Guyana, CountryRegion.Caribbean],
  [Country.Haiti, CountryRegion.Caribbean],
  [Country.Honduras, CountryRegion.Central],
  [Country.Jamaica, CountryRegion.Caribbean],
  [Country.México, CountryRegion.Central],
  [Country.Montserrat, CountryRegion.Caribbean],
  [Country.Nicaragua, CountryRegion.Central],
  [Country.Panamá, CountryRegion.Central],
  [Country.Paraguay, CountryRegion.Tropical],
  [Country.Perú, CountryRegion.Andean],
  [Country.PuertoRico, CountryRegion.Caribbean],
  [Country.SaintLucia, CountryRegion.Caribbean],
  [Country.SaintVincentandtheGrenadines, CountryRegion.Caribbean],
  [Country.StKittsNevis, CountryRegion.Caribbean],
  [Country.Suriname, CountryRegion.Caribbean],
  [Country.TrinidadandTobago, CountryRegion.Caribbean],
  [Country.TurksCaicos, CountryRegion.Caribbean],
  [Country.Uruguay, CountryRegion.South],
  [Country.Venezuela, CountryRegion.Central],
]);

const CountryFlags: Map<Country, string> = new Map([
  [Country.Anguila, "assets/flags/ai.svg"],
  [Country.AntiguaAndBarbuda, "assets/flags/ag.svg"],
  [Country.Argentina, "assets/flags/ar.svg"],
  [Country.Bahamas, "assets/flags/bs.svg"],
  [Country.Barbados, "assets/flags/bb.svg"],
  [Country.Belize, "assets/flags/bz.svg"],
  [Country.Bermuda, "assets/flags/bm.svg"],
  [Country.Bolivia, "assets/flags/bo.svg"],
  [Country.Brasil, "assets/flags/br.svg"],
  [Country.BritishVirginIslands, "assets/flags/vg.svg"],
  [Country.Canada, "assets/flags/ca.svg"],
  [Country.Chile, "assets/flags/cl.svg"],
  [Country.Colombia, "assets/flags/co.svg"],
  [Country.CostaRica, "assets/flags/cr.svg"],
  [Country.Cuba, "assets/flags/cu.svg"],
  [Country.Dominica, "assets/flags/dm.svg"],
  [Country.DominicanRepublic, "assets/flags/do.svg"],
  [Country.Ecuador, "assets/flags/ec.svg"],
  [Country.ElSalvador, "assets/flags/sv.svg"],
  [Country.EstadosUnidosdeNA, "assets/flags/us.svg"],
  [Country.Grenada, "assets/flags/gd.svg"],
  [Country.Groenlandia, "assets/flags/gl.svg"],
  [Country.Guatemala, "assets/flags/gt.svg"],
  [Country.Guyana, "assets/flags/gy.svg"],
  [Country.Haiti, "assets/flags/ht.svg"],
  [Country.Honduras, "assets/flags/hn.svg"],
  [Country.Jamaica, "assets/flags/jm.svg"],
  [Country.México, "assets/flags/mx.svg"],
  [Country.Montserrat, "assets/flags/ms.svg"],
  [Country.Nicaragua, "assets/flags/ni.svg"],
  [Country.Panamá, "assets/flags/pa.svg"],
  [Country.Paraguay, "assets/flags/py.svg"],
  [Country.Perú, "assets/flags/pe.svg"],
  [Country.PuertoRico, "assets/flags/pr.svg"],
  [Country.SaintLucia, "assets/flags/lc.svg"],
  [Country.SaintVincentandtheGrenadines, "assets/flags/vc.svg"],
  [Country.StKittsNevis, 'assets/flags/kn.svg'],
  [Country.Suriname, "assets/flags/sr.svg"],
  [Country.TrinidadandTobago, "assets/flags/tt.svg"],
  [Country.TurksCaicos, "assets/flags/tc.svg"],
  [Country.Uruguay, "assets/flags/uy.svg"],
  [Country.Venezuela, "assets/flags/ve.svg"],
]);

export function getFlagForCountry(country: Country) {
  let path = "assets/flags/un.svg";
  CountryFlags.forEach((value: string, key: Country) => {
    if (key === country) {
      path = value;
    }
  });
  return path;
}